import React from "react";
import { Typography, Chip, useTheme } from "@mui/material";
import styled from "styled-components";
import { Box } from "@mui/material";

const SD = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 10px auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  * {
    font-size: 10px;
  }
`;

const PB = styled.div`
  display: block;
  margin: 10px auto;
  background: linear-gradient(
    to left,
    ${(p) =>
      p.theme.palette.primary.main + ", " + p.theme.palette.secondary.main}
  );
  height: 10px;
  border-radius: 10px;
  width: ${({ ps, max }) => (ps / max) * 99}%;
  transition: 0.5s ease;
`;

export default function ProgressBar({ position, sections }) {
  const max = sections[position[0]].questions.length;

  const theme = useTheme();

  return (
    <SD>
      {/* <PB ps={position[1] + 1} max={max} theme={theme} /> */}
      <Typography
        sx={{
          fontSize: "10px",
        }}
      >
        Q. No:
      </Typography>
      <Chip
        sx={{
          px: 1,
          mx: 1,
        }}
        label={`${position[1] + 1}/${max}`}
      />

      <Box
        sx={{
          flex: 1,
          flexGrow: 1,
          position: "relative",
          my: "auto",
          mx: "10px",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "5px",
            borderRadius: "3px",
            position: "absolute",
            left: 0,
            top: "-5px",
            background: "whitesmoke",
          }}
        />
        <div
          style={{
            width: `${((position[1] + 1) / max) * 100}%`,
            height: "5px",
            borderRadius: "3px",
            position: "absolute",
            left: 0,
            top: "-5px",
            background: theme.palette.primary.main,
            transition: "0.3s ease",
          }}
        />
        <div
          style={{
            left: `${((position[1] + 1) / max) * 100}%`,
            borderRadius: "50%",
            position: "absolute",
            width: "20px",
            height: "20px",
            top: "-12px",
            border: "2px solid rgba(255,255,255,0.6)",
            background: theme.palette.primary.main,
            transition: "0.3s ease",
          }}
        />
      </Box>

      {/* <Box sx={{ display: "block", width: "100%", textAlign: "center" }}>
        <Typography sx={{ color: "gray" }}></Typography>
      </Box> */}
    </SD>
  );
}
